import { extractRings, type LngLatRing } from "./geo.js";

/**
 * Loads the vendored Natural Earth 110m land outline once per page and
 * hands every mounted globe the same rings.
 *
 * The cache is module-level on purpose: React 18/19 StrictMode alone mounts
 * every component twice in development, and the file cannot change between
 * mounts.
 */
export const LAND_URL = "/data/ne_110m_land.geojson";

let cached: Promise<LngLatRing[]> | null = null;

export function loadLandRings(url: string = LAND_URL): Promise<LngLatRing[]> {
  if (!cached) {
    cached = (async () => {
      try {
        const res = await fetch(url, { credentials: "omit" });
        if (!res.ok) return [];
        return extractRings(await res.json());
      } catch {
        // No coastlines is a survivable outcome (an oceans-only planet);
        // a rejected promise on a sign-in screen is not. `extractRings`
        // is already total, so this only catches transport/JSON failures.
        return [];
      }
    })();
  }
  return cached;
}

/** Test seam — drops the module-level cache so a suite can exercise the
 * loader more than once. Not used by the app. */
export function resetLandCache(): void {
  cached = null;
}
